import React from "react";
import Tippy from "@tippyjs/react";
import copyIcon from "../../assets/img/common/copyImg.svg";
import customToast from "../../components/common/basic/Toast";

const TippyCopy = ({ content, className, iconClassName, iconStyle, iconType = "normal", isGroupDiscount, endTime, timeZone }) => {
	const disabledStyle = {
		cursor: "not-allowed",
		opacity: 0.5,
		pointerEvents: "none",
	};

	const isDisabled = isGroupDiscount || (endTime && new Date() > new Date(endTime));

	const handleCopy = () => {
		if (!isDisabled) {
			navigator.clipboard.writeText(content).then(() => {
				customToast.success("Copied to Clipboard");
			}).catch(err => {
				console.error("Failed to copy: ", err);
			});
		}
	};

	const getIcon = () => {
		if (iconType === "outline") {
			return (
				<img
					style={isDisabled ? disabledStyle : { cursor: "pointer" }}
					src={copyIcon}
					alt="copyIcon"
					className="ml-2 cpybtn"
					onClick={handleCopy}
				/>
			);
		} else {
			return (
				<i
					className={`fas fa-copy ${iconClassName}`}
					style={isDisabled ? disabledStyle : iconStyle}
					onClick={handleCopy}
				></i>
			);
		}
	};

	return (
		<div className={`d-inline-block ${className || ""}`}>
			<Tippy
				animation="fade"
				theme="custom"
				content="Copied"
				placement="bottom"
				trigger="click"
				className="custom-tippy"
				onShow={instance => {
					setTimeout(() => {
						instance.hide();
					}, 1000);
				}}
			>
				{getIcon()}
			</Tippy>
		</div>
	);
};

export default TippyCopy;
